import { combineReducers } from 'redux';

import dice from './diceReducer';
import suit from './suitReducer';
import hand from './handReducer';
import leftPlayer from './leftPlayerReducer';
import topPlayer from './topPlayerReducer';
import rightPlayer from './rightPlayerReducer';
import clock from './clockReducer';
import score from './scoreReducer';
import ingame from './ingameReducer';
import redirect from './redirectReducer';
import myIndex from './myIndexReducer';

const rootReducer = combineReducers({
	dice,
	suit,
	hand,
	rightPlayer,
	topPlayer,
	leftPlayer,
	clock,
	score,
	ingame,
	redirect,
	myIndex,
	// socket,
});

export default rootReducer;
